
/* eslint-disable */
    import {useStore} from "@/store";
    // , computed, ComputedRef, watch, reactive
    import {defineComponent, reactive, ComputedRef, computed, toRefs} from "vue";
    import imgSrcAccident from '@/assets/toc/accidentImg.png';
    import imgSrcFire from '@/assets/toc/fireImg.png';
    import imgSrcWater from '@/assets/toc/waterImg.png';
    import iconOk from '@/assets/toc/ok.png';
    import iconWarn from '@/assets/toc/warn.png';
    import iconTip from '@/assets/toc/tip.png';
    import  reportMsgUt from "@/util/reportMsg";

     interface State {
         imgSrc: string;
         content: string;
         icon: string;
         tit: string;
         nopadding: boolean;
         smallpadding: boolean;
         contentAccidentNo: string;
         contentAccidentNo_new: string;
         contentAccidentNo_old: string;
         contentAccident1_new: string;
         contentAccident1_old: string;
         contentAccident2_new: string;
         contentAccident2_old: string;
         contentAccidentYes: string;
         contentFireNo: string;
         contentFireYes: string;
         contentWaterNo: string;
         contentWaterYes: string;
         contentShowType: boolean;
         reportMsg: object;

     }
export default defineComponent({
    name: 'checkDescrip',
    props: {
        itemCode: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        //
        let state: State = reactive({
            imgSrc: '',
            content: '',
            icon: '',
            tit: '',
            nopadding: false,
            smallpadding: false,
            contentShowType: false,
            contentAccidentNo: '经检测该车结构件及加强件（如纵梁、ABCD柱、防火墙、底大边内侧、翼子板内骨架、导水槽、水箱框架等56处部件）未存在钣金修复、严重变形、切割等修复痕迹，从而综合判断该车不存在事故性损伤，排除事故车，具体标准详见检测保障承诺书附件《检测认定标准》。',
            contentAccidentNo_new: '经检查该车结构件及加强件（如纵梁、ABCD柱、防火墙、底大边内侧、翼子板内骨架、导水槽、水箱框架等56处部件）未存在钣金修复、严重变形、切割等修复痕迹，从而综合判断该车不存在事故性损伤，排除事故车，具体标准详见检测保障承诺书附件《检测认定标准》。',
            contentAccidentNo_old: '经检查该车前后纵梁、ABCD柱、顶边梁，底边梁、减震器座、车底纵梁等主要结构部件未发生整体变形、切割修复痕迹。防火墙、后围板、水箱框架等主要加强件、未发现切割焊接痕迹。从而综合判断该车不存在结构性损伤，排除重大事故。',
            contentAccident1_new: '经检测该车加强件（如底大边内侧、翼子板内骨架、导水槽等22处部位）存在一处或多处严重变形、钣金修复、烧焊、锈蚀锈透等任一缺陷，或前后灯框架存在切割缺陷时，认定为事故车，具体标准详见检测保障承诺书附件《检测认定标准》。',
            contentAccident1_old: '经检查该车前后纵梁、ABCD柱、顶边梁，底边梁、减震器座、车底纵梁等主要结构部件未发生整体变形、切割修复痕迹。防火墙、后围板、水箱框架等主要加强件、未发现切割焊接痕迹。从而综合判断该车不存在结构性损伤，排除重大事故。',
            contentAccident2_new: '经检测该车结构件（如纵梁、ABCD柱、防火墙等24处部位）存在一处或多处钣金修复、严重变形、切割、锈蚀锈透任一缺陷，或加强件（如底大边、翼子板内骨架等21处部位） 中有存在一处或多处切割缺陷时，认定为重大事故车，具体标准详见检测保障承诺书附件《检测认定标准》。',
            contentAccident2_old: '经检测如车辆结构件 (如纵梁、ABCD柱、防火墙等24处部位) 存在钣金修复、严重变形、切割、锈蚀锈透任一缺陷，或加强件 (如底大边、翼子板内骨架等21处部位) 中有存在切割缺陷时，认定为重大事故车，具体标准详见检测保障承诺书附件《检测认定标准》。',
            contentAccidentYes: '经检测如车辆结构件（如纵梁、ABCD柱、防火墙等24处部位）存在钣金修复、严重变形、切割、锈蚀锈透任一缺陷，或加强件（如底大边、翼子板内骨架等21处部位）中有存在切割缺陷时，认定为重大事故车，具体标准详见检测保障承诺书附件《检测认定标准》。',
            contentFireNo: '经检测如车辆（如减震器座、发动机舱、行李箱舱等19项部位）未存在烟熏、碳化、受热变形任一情况，或存在烟熏、碳化、受热变形任一情况，但单个部件缺陷面积小于0.3平方米，即认定为非火烧车，具体标准详见检测保障承诺书附件《检测认定标准》。',
            contentFireYes: '经检测如车辆（如减震器座、发动机舱、行李箱舱等19项部位）中有存在烟熏、碳化、受热变形任一情况，且单个部件缺陷面积大于等于0.3平方米，即认定为火烧车，具体标准详见检测保障承诺书附件《检测认定标准》。',
            contentWaterNo: '经检测如车辆（如发动机舱、驾驶室、地胶（毯）等43项部位）中未存在明显的水印、泥沙、锈蚀、霉斑、泡水修复等迹象，或有存在迹象但未达到三处，认定为非泡水车，具体标准详见检测保障承诺书附件《检测认定标准》。',
            contentWaterYes: '经检测如车辆（如发动机舱、驾驶室、地胶（毯）等43项部位）中存在明显的水印、泥沙、锈蚀、霉斑、泡水修复等迹象，且达到三处或三处以上，认定为泡水车，具体标准详见检测保障承诺书附件《检测认定标准》。',
            reportMsg: {},
        })
        state.reportMsg = reportMsgUt;
        const {itemCode} = toRefs(props)
        // console.dir(props);
        let store = useStore()
        let isFire: ComputedRef<{}> = computed<{}>(() => (store.state.dataInfo as any).isFire);
        let isWater: ComputedRef<{}> = computed<{}>(() => (store.state.dataInfo as any).isWater);
        let isAccident: ComputedRef<{}> = computed<{}>(() => (store.state.dataInfo as any).isAccident);
        let accidentFlag: ComputedRef<{}> = computed<{}>(() => (store.state.dataInfo as any).accidentFlag);
        let newAccidentRule: ComputedRef<{}> = computed<{}>(() => (store.state.dataInfo as any).newAccidentRule);
        let accidentResult: ComputedRef<string> = computed<string>(() => (store.state.dataInfo as any).accidentResult);
        let accidentDeclare: ComputedRef<string> = computed<string>(() => (store.state.dataInfo as any).accidentDeclare);
        let fireResult: ComputedRef<string> = computed<string>(() => (store.state.dataInfo as any).fireResult);
        let fireDeclare: ComputedRef<string> = computed<string>(() => (store.state.dataInfo as any).fireDeclare);
        let waterResult: ComputedRef<string> = computed<string>(() => (store.state.dataInfo as any).waterResult);
        let waterDeclare: ComputedRef<string> = computed<string>(() => (store.state.dataInfo as any).waterDeclare);
        let desCont: ComputedRef<{}> = computed<{}>(() => {
            let obj={
                src: '',
                isWrong: false,
                cont: '',
                icon: '',
                tit: '',
                nopadding: false,
                smallpadding: false,
            };
            let tit = '';
            // console.log(itemCode.value);
            switch (itemCode.value) {
                case 'Accident':
                    obj.src = imgSrcAccident;
                    obj.nopadding = true
                    if (accidentFlag.value === 2) {
                        obj.cont =  newAccidentRule.value ? state.contentAccident2_new : state.contentAccident2_old;
                        obj.isWrong = true;
                        obj.icon = iconWarn;
                        tit = '经检测，认定此车为重大事故车';
                    } else if (accidentFlag.value === 1) {
                        obj.cont =  newAccidentRule.value ? state.contentAccident1_new : state.contentAccident1_old;
                        obj.isWrong = false;
                        obj.icon = newAccidentRule.value ? iconTip : iconOk;
                        tit = newAccidentRule.value ? '经检测，认定此车为事故车' : '经检测，排除此车重大事故车' ;
                    } else if (accidentFlag.value === 0){
                        obj.cont =  newAccidentRule.value ? state.contentAccidentNo_new : state.contentAccidentNo_old;
                        obj.isWrong = false;
                        obj.icon = iconOk;
                        tit = '经检测，排除此车事故车';
                    } else if (isAccident.value === 0) {
                        obj.cont =  state.contentAccidentNo_old;
                        obj.isWrong = false;
                        obj.icon = iconOk;
                        tit = '经检测，排除此车事故车';
                    } else if (isAccident.value === 1) {
                        obj.cont =  state.contentAccidentYes;
                        obj.isWrong = true;
                        obj.icon = iconWarn;
                        tit = '经检测，认定此车为事故车';
                    }
                    obj.tit = accidentResult.value ? accidentResult.value : tit;
                    break;
                case 'Fire':
                    obj.src = imgSrcFire;
                    if (isFire.value) {
                        obj.cont = state.contentFireYes;
                        obj.isWrong = true;
                        obj.icon = iconWarn;
                        tit = '经检测，认定此车为火烧车';
                    } else {
                        obj.cont =  state.contentFireNo;
                        obj.isWrong = false;
                        obj.icon = iconOk;
                        tit = '经检测，排除此车火烧车';
                    }
                    obj.tit = fireResult.value ? fireResult.value : tit;
                    break;
                case 'SoakWater':
                    obj.src = imgSrcWater;
                    obj.smallpadding = true
                    if (isWater.value) {
                        obj.cont =  state.contentWaterYes;
                        obj.isWrong = true;
                        obj.icon = iconWarn;
                        tit = '经检测，认定此车为泡水车';
                    } else {
                        obj.cont =  state.contentWaterNo;
                        obj.isWrong = false;
                        obj.icon = iconOk;
                        tit = '经检测，排除此车泡水车';
                    }
                    obj.tit = waterResult.value ? waterResult.value : tit;
                    break;
            }
            return obj;
        });
        // console.log(desCont);
       (state as any).imgSrc = (desCont.value as any).src;
       (state as any).content = (desCont.value as any).cont;
       (state as any).tit = (desCont.value as any).tit;
       (state as any).icon = (desCont.value as any).icon;
       (state as any).nopadding = (desCont.value as any).nopadding;
       (state as any).smallpadding = (desCont.value as any).smallpadding;
       function changeShowType() {
           state.contentShowType = !state.contentShowType;
       }
        return {
            state,
            changeShowType
        }
    },
    
})
